module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tree-container"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    staticStyle: {
      "padding-top": "15px",
      "margin-left": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "货号",
      "clearable": ""
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPriceReviewList
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.reviewPriceDo(1)
      }
    }
  }, [_vm._v("审核全部通过")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.reviewList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "min_activity_price",
      "label": "活动价",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n         " + _vm._s(scope.row.min_activity_price / 100) + "\n       ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "市场价",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n         " + _vm._s(scope.row.market_price / 100) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "开始时间",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n       " + _vm._s(_vm._f("datetime")(scope.row.start_time, 'yyyy-MM-dd hh:mm')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end_time",
      "label": "结束时间",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n       " + _vm._s(_vm._f("datetime")(scope.row.end_time, 'yyyy-MM-dd hh:mm')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upload_user",
      "label": "上传人员",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upload_time",
      "label": "上传时间",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n     " + _vm._s(_vm._f("datetime")(scope.row.upload_time, 'yyyy-MM-dd hh:mm')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "review_user",
      "label": "审核人员",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "review_time",
      "label": "审核时间",
      "width": "230"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n       " + _vm._s(_vm._f("datetime")(scope.row.review_time, 'yyyy-MM-dd hh:mm')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "review_status",
      "label": "审核状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.review_status == '0') ? _c('el-tag', [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (scope.row.review_status == '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.review_status == '2') ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("拒绝")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.reviewPriceDoOne(scope.row.id, 1)
            }
          }
        }, [_vm._v("\n           审核通过\n         ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.reviewPriceDoOne(scope.row.id, 2)
            }
          }
        }, [_vm._v("\n           审核拒绝\n         ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "模板格式 文件名称格式x年x月x日商品审核.xlsx",
      "visible": _vm.dialogS
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogS = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.tempImg
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.hideTmp
    }
  }, [_vm._v("下载模板")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3608f56a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3608f56a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/priceviewlist.vue
// module id = 2611
// module chunks = 0